export enum ActivityRole {
    Bot = "bot",
    User = "user",
}
